import { handleActions } from 'redux-actions';
import * as actions from './inputs.actions';

const initialState = {};

const setResourcesState = (state, { payload }) => {
  return { ...state, ...payload };
};

const InputsResources = handleActions(
  {
    [actions.setResourcesAction as any]: setResourcesState,
  },
  initialState,
);

export default InputsResources;
